import { getPortfolioNewsFeed } from '@simplywallst/services';
import { useQuery } from '@tanstack/react-query';
import { selector } from './selector';
import { withAuth } from '@/utilities/queries';
import useUser from '@/hooks/useUser';

const getQueryKey = (portfolioId: string, isLoggedIn: boolean) => {
  return ['portfolioNewsFeed', portfolioId, isLoggedIn];
};

const queryFn = async (portfolioId: string, isLoggedIn: boolean) => {
  const response = isLoggedIn
    ? await withAuth(getPortfolioNewsFeed, portfolioId)
    : await getPortfolioNewsFeed(portfolioId);
  const { data } = response.data;
  return data;
};

export const useNewsFeed = (portfolioId: string) => {
  const { data: userData } = useUser();

  const {
    data = { keys: [], entities: {} },
    status,
    isFetched,
    isFetching,
  } = useQuery({
    queryKey: getQueryKey(portfolioId, userData.loggedIn),
    queryFn: () => queryFn(portfolioId, userData.loggedIn),
    select: selector,
  });

  const { keys, entities } = data;

  return {
    keys,
    entities,
    isFetching,
    status,
    isFetched,
  };
};
